import { action } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Loader, Modal, ModalHandle, TasksStore, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';
import { Button, ButtonGroup } from 'reactstrap';
import { CreateOrEditModelDefinition } from './CreateOrEditModelDefinition';
import { ModelDefinitionsStore } from './ModelDefinitionsStore';

export interface IModelDefinitionItemProps {
    readonly modelDefinition: Mri.ModelDefinitions.ModelDefinition;
}

@autoinject
@observer
export class ModelDefinitionItem extends React.Component<IModelDefinitionItemProps> {
    public render() {
        const modelDefinition = this.props.modelDefinition;

        return (
            <tr>
                <td className="align-middle">{modelDefinition.modelNumber}</td>

                <td className="align-middle">{modelDefinition.partNumber}</td>

                <td className="align-middle">{modelDefinition.description}</td>

                <td className="align-middle">
                    <ButtonGroup className="py-1">
                        <Tooltip message="Edit Model" delay={0}>
                            <Button color="primary" onClick={this.modalHandle.open}>
                                <BsPencilSquare />
                            </Button>
                        </Tooltip>

                        <Tooltip message="Delete" delay={0}>
                            <Button color="danger" className="dt-border" onClick={this.deleteAsync}>
                                <BsTrash />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>
                </td>

                <CreateOrEditModelDefinition
                    guid={modelDefinition.modelDefinitionGuid}
                    modalHandle={this.modalHandle}
                    viewState="edit"
                />

                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.confirmModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">{`Delete ${this.props.modelDefinition.modelNumber}?`}</div>
                </Modal>
            </tr>
        );
    }

    @bind
    @action
    private async deleteAsync() {
        if (await this.confirmModalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Delete ${this.props.modelDefinition.modelNumber}`);

            try {
                await this.modelDefinitionsStore.deleteAsync(this.props.modelDefinition.modelDefinitionGuid);
                task.complete();
            } catch (e: any) {
                task.error(e);
            }
        }
    }

    private confirmModalHandle = new ModalHandle();
    private modalHandle = new ModalHandle();
    @inject
    private readonly modelDefinitionsStore!: ModelDefinitionsStore;
    @inject
    private readonly tasksStore!: TasksStore;
}
